module.exports = __webpack_public_path__ + "img/cryptocurrency-02.af34e650.svg";